import { useTranslation } from "react-i18next";
import { useState } from "react";
import { MapPin } from "lucide-react";

export default function ContactSection() {
  const { t } = useTranslation();

  const [success, setSuccess] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    form.reset();

    setSuccess(true);

    setTimeout(() => {
      setSuccess(false);
    }, 3000);
  };

  return (
    <section className="px-4 sm:px-6 lg:px-12 pb-16 relative">

      {/* ALERT TOP */}
      {success && (
        <div className="fixed top-6 left-1/2 -translate-x-1/2 z-50 bg-blue-600 text-white px-6 py-3 rounded-full shadow-xl font-bold text-sm transition" style={{zIndex: '1000'}}>
          {t("contact.success")}
        </div>
      )}

      <div className="max-w-[1450px] mx-auto overflow-hidden rounded-[32px] lg:rounded-[64px] border border-slate-50 bg-white shadow-2xl flex flex-col lg:flex-row">

        {/* LEFT */}
        <div className="lg:w-2/5 bg-slate-50 p-8 sm:p-12 lg:p-16 space-y-10 text-left">

          <h2 className="text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter font-black leading-none break-words">
            {t("contact.title1")} <br />
            <span className="text-blue-600">
              {t("contact.title2")}
            </span>
          </h2>

          <p className="text-sm sm:text-base text-slate-400 font-light italic leading-relaxed">
            {t("contact.subtitle")}
          </p>

          <div className="space-y-6 pt-6 border-t border-slate-200">

          {/* EMAIL */}
          <div className="flex items-center gap-5">
            <span className="w-5 text-blue-600 text-xl flex justify-center">✉</span>
            <p className="text-[10px] sm:text-[11px] font-black uppercase tracking-widest break-all">
              {t("contact.email")}
            </p>
          </div>

          {/* LOCATION */}
          <div className="flex items-center gap-5">
            <span className="w-5 flex justify-center">
              <MapPin className="w-5 h-5 text-blue-600" />
            </span>

            <p className="text-[10px] sm:text-[11px] font-black uppercase tracking-widest break-all">
              {t("footer.location")}
            </p>
          </div>

          {/* PHONE */}
          <div className="flex items-center gap-5">
            <span className="w-5 text-blue-600 text-xl flex justify-center">📞</span>
            <p className="text-[10px] sm:text-[11px] font-black uppercase tracking-widest break-all">
              {t("contact.phone")}
            </p>
          </div>

        </div>
        </div>

        {/* RIGHT */}
        <div className="lg:w-3/5 bg-white p-8 sm:p-12 lg:p-16 flex items-center">

          <form
            onSubmit={handleSubmit}
            className="w-full space-y-8 sm:space-y-10"
          >

            <input
              type="email"
              required
              placeholder={t("contact.form.email") as string}
              className="w-full border-b-2 border-slate-100 py-5 sm:py-6 outline-none transition focus:border-blue-600 font-black text-xs sm:text-sm tracking-[0.2em] uppercase"
            />

            <input
              type="text"
              required
              placeholder={t("contact.form.name") as string}
              className="w-full border-b-2 border-slate-100 py-5 sm:py-6 outline-none transition focus:border-blue-600 font-black text-xs sm:text-sm tracking-[0.2em] uppercase"
            />

            <input
              type="text"
              required
              placeholder={t("contact.form.question") as string}
              className="w-full border-b-2 border-slate-100 py-5 sm:py-6 outline-none transition focus:border-blue-600 font-black text-xs sm:text-sm tracking-[0.2em] uppercase"
            />

            <button className="w-full sm:w-auto bg-slate-900 text-white px-10 sm:px-16 py-5 sm:py-6 rounded-full font-black text-[10px] sm:text-[11px] uppercase tracking-[0.3em] sm:tracking-[0.4em] shadow-2xl hover:bg-blue-600 transition duration-500 active:scale-95">
              {t("contact.button")}
            </button>

          </form>
        </div>
      </div>
    </section>
  );
}